import React, { useState } from "react";
import Styles from './styles.module.scss';

import projectIcon from '../../theme/assets/other/lp_cabinet_project_icon.png';
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const LaunchpadProjects = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const userProjects = useSelector(store => store.cabinet.userProjects) || [];
    const userData = useSelector(store => store.cabinet.userData);

    // fallback if project doesn't have image
    const projects = userProjects.map(p => ({
        image: p.logo || projectIcon,
        title: p.description?.title || 'Unnamed Project',
        slug: p.slug || 'unnamed-project'
    }));

    const [page, setPage] = useState(0);
    const perPage = 3;

    const totalPages = Math.ceil(projects.length / perPage);
    const currentProjects = projects.slice(page * perPage, (page + 1) * perPage);
    const emptySlots = perPage - currentProjects.length;

    const nextPage = () => {
        if (page < totalPages - 1) setPage(prev => prev + 1);
    };

    const prevPage = () => {
        if (page > 0) setPage(prev => prev - 1);
    };

    const iconHandler = (isActive) => (
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.79205 10.063C7.08494 10.3559 7.08494 10.8308 6.79205 11.1237C6.49915 11.4166 6.02428 11.4166 5.73139 11.1237L1.20823 6.45994C0.915339 6.16705 0.915339 5.69217 1.20823 5.39928C1.50113 5.10639 1.976 5.10639 2.26889 5.39928L6.79205 10.063Z" fill={isActive ? "#FFD600" : "#AFA293"} />
            <path d="M2.26889 6.45994C1.976 6.75283 1.50113 6.75283 1.20823 6.45994C0.915339 6.16705 0.915339 5.69217 1.20823 5.39928L5.73123 0.876286C6.02412 0.583393 6.499 0.583393 6.79189 0.876286C7.08478 1.16918 7.08478 1.64405 6.79189 1.93695L2.26889 6.45994Z" fill={isActive ? "#FFD600" : "#AFA293"} />
        </svg>
    );

    return (
        <section className={Styles.container}>
            <div className={Styles.contentWrap}>
                <div className={Styles.titleRow}>
                    <div className={Styles.titleRowName}>{t('Мои проекты')}</div>
                    <div className={Styles.titleRowCount}>{userData?.user?.active_projects || '0'}/{userProjects?.length || '0'}</div>
                </div>
                <div className={Styles.contentBox}>
                    {currentProjects.map((item, index) => (
                        <div className={Styles.contentBoxItem} key={`project-${index}`} onClick={()=>{navigate(`/projects/${item.slug}`)}}>
                            <img src={item.image} alt={item.title} />
                            {/*<div className={Styles.contentBoxItemName}>{item.title}</div>*/}
                        </div>
                    ))}
                    {[...Array(emptySlots)].map((_, index) => (
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemEmpty}`} key={`upcoming-${index}`}>
                            <div className={Styles.contentBoxItemName}>UPCOMING!</div>
                        </div>
                    ))}
                </div>
                <div className={Styles.btnWrap}>
                    <div className={`${Styles.btnItem} ${page > 0 ? '' : Styles.btnItemP}`} onClick={prevPage}>
                        {iconHandler(page > 0)}
                    </div>
                    <div className={`${Styles.btnItem} ${page < totalPages - 1 ? '' : Styles.btnItemP}`} onClick={nextPage}>
                        {iconHandler(page < totalPages - 1)}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LaunchpadProjects;
